export const ROUTES = {
  AUTH: {
    LOGIN: "/login",
  },
  DASHBOARD: "/dashboard",
  MASTER_DATA: {
    REGION: {
      LIST: "/master/region",
      CREATE: "/master/region/create",
      DETAIL: "/master/region/:id",
      EDIT: "/master/region/:id/edit",
    },
    CITY: {
      LIST: "/master/city",
      CREATE: "/master/city/create",
      DETAIL: "/master/city/:id",
      EDIT: "/master/city/:id/edit",
    },
    POSTAL_CODE: {
      LIST: "/master/postal",
      CREATE: "/master/postal/create",
      DETAIL: "/master/postal/:id",
      EDIT: "/master/postal/:id/edit",
    },
    BANNERS: {
      LIST: "/master/banners",
      CREATE: "/master/banners/create",
      DETAIL: "/master/banners/:id",
      EDIT: "/master/banners/:id/edit",
    },
    ALLERGIES: {
      LIST: "/master/allergy",
      CREATE: "/master/allergy/create",
      DETAIL: "/master/allergy/:id",
      EDIT: "/master/allergy/:id/edit",
    },
    DIETARY: {
      LIST: "/master/dietary",
      CREATE: "/master/dietary/create",
      DETAIL: "/master/dietary/:id",
      EDIT: "/master/dietary/:id/edit",
    },
    COUNTRY: {
      LIST: "/master/country",
      CREATE: "/master/country/create",
      DETAIL: "/master/country/:id",
      EDIT: "/master/country/:id/edit",
    },
    LANGUAGE: {
      LIST: "/master/language",
      CREATE: "/master/language/create",
      DETAIL: "/master/language/:id",
      EDIT: "/master/language/:id/edit",
    },
    USERS: {
      LIST: "/master/users",
      CREATE: "/master/users/create",
      DETAIL: "/master/users/:id",
      EDIT: "/master/users/:id/edit",
    },
    CHEF_CATEGORY: {
      LIST: "/master/chef-category",
      CREATE: "/master/chef-category/create",
      DETAIL: "/master/chef-category/:id",
      EDIT: "/master/chef-category/:id/edit",
    },
    CUSTOMER: {
      LIST: "/master/customer",
      DETAIL: "/master/customer/:id",
    },
    HELPER: {
      LIST: "/master/helper",
      DETAIL: "/master/helper/:id",
    },
    COURSE: {
      LIST: "/master/course",
      CREATE: "/master/course/create",
      DETAIL: "/master/course/:id",
      EDIT: "/master/course/:id/edit",
    },
    KNOWLEDGE: {
      LIST: "/master/knowledge",
      CREATE: "/master/knowledge/create",
      DETAIL: "/master/knowledge/:id",
      EDIT: "/master/knowledge/:id/edit",
    },
  },
  MEAL: {
    MAIN: {
      LIST: "/meal/main",
      CREATE: "/meal/main/create",
      DETAIL: "/meal/main/:id",
      EDIT: "/meal/main/:id/edit",
    },
    TYPE: {
      LIST: "/meal/type",
      CREATE: "/meal/type/create",
      DETAIL: "/meal/type/:id",
      EDIT: "/meal/type/:id/edit",
    },
    CATEGORY: {
      LIST: "/meal/category",
      CREATE: "/meal/category/create",
      DETAIL: "/meal/category/:id",
      EDIT: "/meal/category/:id/edit",
    },
    PRODUCT: {
      LIST: "/meal/product",
      CREATE: "/meal/product/create",
      DETAIL: "/meal/product/:id",
      EDIT: "/meal/product/:id/edit",
    },
    PRODUCT_SCRAPER: "/meal/product-scraper",
    WEEKLY_RECOMMENDED: {
      LIST: "/meal/weekly-recommended",
    },
  },
  OPERATIONAL: {
    TRANSACTION: {
      LIST: "/operational/transaction",
      DETAIL: "/operational/transaction/:id",
    },
    DISPUTE: {
      LIST: "/operational/dispute",
      DETAIL: "/operational/dispute/:id",
      EDIT: "/operational/dispute/:id/edit",
    },
    ORDERS: {
      LIST: "/operational/orders",
      CREATE: "/operational/orders/create",
      DETAIL: "/operational/orders/:id",
      EDIT: "/operational/orders/:id/edit",
    },
    SUBSCRIPTION: {
      LIST: "/operational/subscribe",
      DETAIL: "/operational/subscribe/:id",
    },
    DISCOUNT_CODE: {
      LIST: "/operational/discount-code",
      CREATE: "/operational/discount-code/create",
      DETAIL: "/operational/discount-code/:id",
      EDIT: "/operational/discount-code/:id/edit",
    },
    BROADCAST: {
      LIST: "/operational/broadcast",
      CREATE: "/operational/broadcast/create",
      DETAIL: "/operational/broadcast/:id",
    },
    SMS_TEST: "/operational/sms-test",
    SMS_LOG: {
      LIST: "/operational/sms-log",
    },
    SMS_TEMPLATE: {
      LIST: "/operational/sms-template",
    },
    INGREDIENT_SHOPPING: {
      LIST: "/operational/ingredient-shopping",
    },
    // List only: one subscription's charges are read on the subscription page
    // itself, which owns that story end to end.
    VISIT_CHARGE_REVIEW: {
      LIST: "/operational/visit-charge-review",
    },
    // A single report screen, not a list: the endpoint returns one computed
    // funnel for the window, with nothing to page through or open.
    INTRO_VISIT_REPORT: "/operational/intro-visit-report",
    DAC7_REPORT: "/operational/dac7-report",
    FAMILY_REQUEST: {
      LIST: "/operational/family-request",
      DETAIL: "/operational/family-request/:id",
    },
    REFERRAL: {
      LIST: "/operational/referral",
    },
  },
  SETTINGS: {
    STATIC_PAGE: {
      LIST: "/settings/static-page",
      CREATE: "/settings/static-page/create",
      DETAIL: "/settings/static-page/:id",
      EDIT: "/settings/static-page/:id/edit",
    },
    SYSTEM: {
      LIST: "/settings/system",
      CREATE: "/settings/system/create",
      DETAIL: "/settings/system/:id",
      EDIT: "/settings/system/:id/edit",
    },
  },
};
